export default "__VITE_ASSET__DhH$qWsI__"